
import clusterStripIcon from '@/assets/img/icon-layers/cluster-strip.svg';
import markerCenter from '@/assets/img/icon-layers/marker-center.svg';
import markerStrip from '@/assets/img/icon-layers/marker-strip.svg';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';

export default class MapIconsGeneratorService {
  public static resolveIconUrl(url: string | null, isBase64IconCode?: boolean): string {
    if (isBase64IconCode && typeof url === 'string' && url.trim() !== '') {
      return `data:image/svg+xml;base64,${url.trim()}`;
    } else if (!isBase64IconCode && typeof url === 'string') {
      return url.trim();
    }

    return '';
  }

  public static getClusterIcon(settings: IClusterIconSettings): string {
    const clusterHtml = `
      <div class="map-cluster ${settings.className}">
        <div
          class="map-cluster__strip"
          style='mask: url("${clusterStripIcon}") center center no-repeat;mask-size: contain;'
        ></div>
        <div
          class="map-cluster__icon"
          style='mask: url("${settings.insideIcon}") center center no-repeat;mask-size: contain;'
        ></div>
        <div class="map-cluster__population">
          <span class="map-cluster__population-value">${settings.population}</span>
        </div>
      </div>
    `;

    return clusterHtml;
  }

  public static getMarkerIcon(settings: IMarkerIconSettings): string {
    const populationTextHtml = settings.populationText && settings.populationText !== ''
      ? `<span class="map-simple-icon__number ${settings.className}">${settings.populationText}</span>`
      : '';
    const markerHtml = `
      <div class="map-marker ${settings.className}"
        style='mask: url("${markerCenter}") center center no-repeat;mask-size: contain;'
      >
        <div
          class="map-marker__strip"
          style='mask: url("${markerStrip}") center center no-repeat;mask-size: contain;'
        ></div>
        <div
          class="map-marker__icon"
          style='mask: url("${this.resolveIconUrl(settings.insideIcon, settings.isBase64IconCode)}") center center no-repeat;mask-size: contain;'
        ></div>
        </div>
        ${populationTextHtml}
    `;

    return markerHtml;
  }
}
